import { axiosInstance } from "./axiosInstance";

export const TestimonyProgramServices = {
  getAll: async (filter) => {
    return await axiosInstance.get('/api/feature/static-asset/group', { params: filter });
  },
  create: async (data) => {
    return await axiosInstance.post('/api/feature/static-asset/group', data);
  },
  update: async (id, data) => {
    return await axiosInstance.post(`/api/feature/static-asset/group/update/${id}`, data);
  },
  delete: async (id) => {
    return await axiosInstance.delete(`/api/feature/static-asset/group/delete/${id}`);
  },
  createAssets: async (data, id) => {
    return await axiosInstance.post(`/api/feature/static-asset/group/asset/${id}`, data);
  },
  deleteAssets: async (id) => {
    return await axiosInstance.delete(`/api/feature/static-asset/group/asset/delete/${id}`);
  },
  attachDetach: async (id, data) => {
    return await axiosInstance.post(`/api/feature/static-asset/group/program/attach-detach/${id}`, data);
  },
  order: async (id, data) => {
    return await axiosInstance.post(`/api/feature/static-asset/group/order/${id}`, data);
  }
}